import { useEffect, useState } from "react";
import Loader from "../../../components/Loader/loader";
import ProductListData from "./data.json";
import ProductSection from "../../../components/ProductSection/product-section";
import NotFound from "../../../components/NotFound/not-found";
import "./product-list.css";

function ProductList() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTitle, setActiveTitle] = useState(null);

  useEffect(() => {
    const getProductList = async () => {
      if (ProductListData.length > 0) {
        setData(ProductListData);
        setActiveTitle(ProductListData[0].title);
      } else {
        setData(null);
        setActiveTitle(null);
      }
      setIsLoading(false);
    }
    getProductList();
  }, []);

  if (isLoading) {
    return <Loader />
  }
  if (!data || data.length === 0) {
    return <NotFound />
  }

  const visibleSections = data.filter((section) => section.title === activeTitle);

  return (
    <div className="product-list">
      <nav className="product-list__filters" aria-label="Categorías de productos">
        {data.map((section) => (
          <button
            key={section.title}
            type="button"
            className={`product-list__filter-btn${section.title === activeTitle ? " product-list__filter-btn--active" : ""}`}
            aria-pressed={section.title === activeTitle}
            onClick={() => setActiveTitle(section.title)}
          >
            {section.title}
          </button>
        ))}
      </nav>
      {visibleSections.map((section) => (
        <ProductSection
          key={section.title}
          data={section}
          elementsByRow={section.elementsByRow || 4}
        />
      ))}
    </div>
  )
}

export default ProductList;